import { Column } from "@mdotm/shadcn/legacy/components";
import { WithRwAtom } from "@mdotm/shadcn/legacy/reactivity";
import { StepperInput, FormField } from "@mdotm/shadcn/mdotm/components";
import { useMandatoryContext } from "@mdotm/utils/react-extra";
import type React from "react";
import { PortfolioLabContext } from "../../../ctx";
import { useLabSession } from "../../../hooks/useLabSession";
import { useDecimalPlaces } from "$root/functional-areas/user/useDecimalPlaces";

/** The live precision stepper bound to `ctx.decimals$` — shared by the inline and stacked stages. */
function RawDecimalStepper(): React.JSX.Element {
	const ctx = useMandatoryContext(PortfolioLabContext);
	const { saveLabSession } = useLabSession();
	const { customerDecimalPlacesPreferences } = useDecimalPlaces();
	return (
		<WithRwAtom atom$={ctx.decimals$}>
			{([decimal, setDecimal]) => (
				<StepperInput
					value={decimal}
					onChange={(newDecimal) => {
						setDecimal(newDecimal);
						saveLabSession();
					}}
					min={2}
					max={customerDecimalPlacesPreferences}
					step={1}
					size={"x-small"}
				/>
			)}
		</WithRwAtom>
	);
}

/** Inline decimal stepper for the toolbar row. `labelled` shows the "Decimal" label before it. */
export function DecimalStepper({ labelled = false }: { labelled?: boolean }): React.JSX.Element {
	if (labelled) {
		return (
			<FormField label="Decimal" className="flex-row gap-2 items-center">
				{() => <RawDecimalStepper />}
			</FormField>
		);
	}
	return <RawDecimalStepper />;
}

/** Labelled decimal stepper for the collapsed popover stage. */
export function DecimalStepperStacked(): React.JSX.Element {
	return (
		<Column gap={4} className="min-w-40">
			<FormField label="Decimal" data-qualifier="PortfolioLab/Toolbar/Decimals">
				{() => <RawDecimalStepper />}
			</FormField>
		</Column>
	);
}
